import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class DeviceChildAPI extends BasicsClass {
    public apiUrls: any = new Map([
        // ['forbideenUserAccount', {
        //     url: '/user/forbid',
        //     name: 'account-forbid',
        //     label: '账户封禁'
        // }],
        ['getDeviceChildTableList', {
            url: '/admin/device/switchList',
            name: 'list',
            label: '列表'
        }],
        
    ])


    // // 子设备列表
    public getDeviceChildTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getDeviceChildTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }


}